import { Divider, Flex, Loader, Stack, Text } from '@mantine/core';
import { FC } from 'react';
import { SummaryTabBlockChildProps } from '../summary-tab/SummaryTab';
import { useTranslation } from 'react-i18next';
import { usePatientNotes } from './usePatientNotes';
import { NotePreviewItem } from './NotePreviewItem';

//------------------------------------------------------------------------------
const PatientNotesPreview: FC<SummaryTabBlockChildProps> = () => {
  const { t } = useTranslation(['patient-pages']);

  const { notes, isLoading } = usePatientNotes();

  // ---------------------------------------------------------------------------
  if (isLoading) {
    return (
      <Flex justify="center" align="center" h="100%">
        <Loader size="sm" />
      </Flex>
    );
  }

  // ---------------------------------------------------------------------------
  return (
    <Stack gap="sm">
      {notes.map((note, index) => (
        <>
          <NotePreviewItem key={note.id} note={note} />
          {index !== notes.length - 1 && <Divider color="gray.1" />}
        </>
      ))}

      {/* Empty State */}
      {notes.length === 0 && (
        <Text size="sm" c="dimmed" ta="center" p="xl">
          {t('notes.empty', {
            ns: 'patient-pages',
            defaultValue: 'No notes yet. Click "Add New Note" to create one.',
          })}
        </Text>
      )}
    </Stack>
  );
};

export default PatientNotesPreview;
